export default __webpack_public_path__ + "static/media/pad-lock-icon.36eaafbf.svg";